export default {
   windowEl: window,
   documentEl: document,
   htmlEl: document.documentElement,
   bodyEl: document.body,
};

export const addClass = (element, className) =>
   element?.classList.add(className);
export const removeClass = (element, className) =>
   element?.classList.remove(className);
export const toggleClass = (element, className) =>
   element?.classList.toggle(className);
